import './Loading.css';

export function Loading({ size = 'medium', text = 'Loading...' }) {
  return (
    <div className="loading" role="status" aria-live="polite">
      <div className={`loading-spinner loading-spinner--${size}`}>
        <div className="loading-spinner-circle"></div>
      </div>
      <span className="loading-text">{text}</span>
    </div>
  );
}

export default Loading;
